import React from "react";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    console.error("ErrorBoundary caught:", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 16,
            background: "#0A0E1A",
            color: "#e2e8f0",
            padding: 24,
            textAlign: "center",
          }}>
          <p style={{ fontSize: 18, fontWeight: 800 }}>
            Nimadir xato ketdi 😕
          </p>
          <p style={{ fontSize: 13, color: "#64748b", maxWidth: 320 }}>
            Sahifani qayta yuklab ko'ring. Muammo davom etsa, bosh sahifaga
            qayting.
          </p>
          <div style={{ display: "flex", gap: 10 }}>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: "10px 18px",
                borderRadius: 10,
                border: "none",
                background: "#3b82f6",
                color: "#fff",
                fontWeight: 700,
                fontSize: 13,
                cursor: "pointer",
              }}>
              Qayta yuklash
            </button>
            <button
              onClick={() => (window.location.href = "/dashboard")}
              style={{
                padding: "10px 18px",
                borderRadius: 10,
                border: "1px solid #1e2d45",
                background: "transparent",
                color: "#e2e8f0",
                fontWeight: 700,
                fontSize: 13,
                cursor: "pointer",
              }}>
              Bosh sahifa
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
